import fetch from 'isomorphic-unfetch/index'

import { getApiURL } from 'helpers/middleware'

const submitNewsletterForm = async formData => {
    const response = await fetch(`${getApiURL('newsletter')}`, {
        mode: 'cors',
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({ ...formData })
    })

    let data = {}
    try {
        data = await response.json()
    } catch (error) {
        data = {}
    }

    if (!response.ok) {
        const message = data.message || data.status || 'Newsletter subscription failed'
        throw new Error(message)
    }

    return data
}

export default submitNewsletterForm
